export default {
    'groups': [
        {
            'label': '1',
            'points': 2,
            'connectivity':
            [
                '0 1',
                '1 0',
            ]
        },
        {
            'label': '2',
            'points': 2,
            'connectivity':
            [
                '0 1',
                '1 0',
            ]
        },
        {
            'label': '3',
            'points': 2,
            'connectivity':
            [
                '0 1',
                '1 0',
            ]
        },
        {
            'label': '4',
            'points': 2,
            'connectivity':
            [
                '0 1',
                '1 0',
            ]
        },
        {
            'label': 'c',
            'points': 4,
            'connectivity':
            [
                '0 1',
                '1 2',
                '2 3',
                '3 0',
            ]
        },
        {
            'label': 'i',
            'points': 1,
            'connectivity':
                [
                    '0 0',
                ]
        },
        {
            'label': 'm',
            'points': 1,
            'connectivity':
                [
                    '0 0',
                ]
        }
    ]
};



// WEBPACK FOOTER //
// ./src/js/app/template/hand-new.js